import React from 'react'
import { makeStyles } from '@mui/styles'

interface PulsingIconProps {
  IconComponent: React.ElementType // El componente del icono a utilizar
  maxScale?: number // Tamaño máximo del icono durante la animación
  duration?: string // Duración de la animación (por ejemplo, "1.5s")
  initialColor?: string // Color inicial del icono durante la animación
  finalColor?: string // Color final del icono durante la animación
  initialOpacity?: number // Opacidad inicial del icono durante la animación
  finalOpacity?: number // Opacidad final del icono durante la animación
  fontSize?: 'small' | 'inherit' | 'default' | 'large' // Tamaño del icono
  color?: string // Color base del ícono fuera de la animación
}

const PulsingIcon: React.FC<PulsingIconProps> = ({
  IconComponent,
  maxScale = 2, // Valor predeterminado para maxScale
  duration = '1.5s', // Valor predeterminado para la duración de la animación
  initialColor = 'grey', // Valor predeterminado para el color inicial
  finalColor = 'black', // Valor predeterminado para el color final
  initialOpacity = 0.5, // Valor predeterminado para la opacidad inicial
  finalOpacity = 1, // Valor predeterminado para la opacidad final
  fontSize = 'large', // Tamaño del icono por defecto
  color = 'inherit' // Color base del ícono fuera de la animación
}) => {
  // Tamaño de escala máximo que será utilizado para ajustar el tamaño del contenedor
  const containerScale = maxScale > 1 ? maxScale : 1

  const useStyles = makeStyles({
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: `calc(${containerScale} * 48px)`, // Ajusta el ancho del contenedor según el tamaño máximo del ícono
      height: `calc(${containerScale} * 48px)` // Ajusta la altura del contenedor según el tamaño máximo del ícono
    },
    pulsingIcon: {
      animation: `$pulse ${duration} ease-in-out infinite`,
      color: color // Aplica el color base cuando el ícono no está animándose
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
        color: initialColor,
        opacity: initialOpacity
      },
      '50%': {
        transform: `scale(${maxScale})`,
        color: finalColor,
        opacity: finalOpacity
      },
      '100%': {
        transform: 'scale(1)',
        color: initialColor,
        opacity: initialOpacity
      }
    }
  })

  const classes = useStyles()

  return (
    <div className={classes.iconContainer}>
      <IconComponent className={classes.pulsingIcon} fontSize={fontSize} />
    </div>
  )
}

export default PulsingIcon
